<template>
  <div class='d-flex align-center justify-space-between pl-0 pr-4'>
    <div>
      <v-tooltip top>
        <template v-slot:activator='{ on, attrs }'>
          <v-icon :color="likeFlag ? 'primary' : ''" v-bind='attrs' v-on='on' @click="addLike('up')"
                  size='20'
                  class='cursor-pointer ml-2'>
            {{ icons.mdiThumbUpOutline }}
          </v-icon>
        </template>
        <span>Like</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator='{ on, attrs }'>
          <v-icon :color="downLikeFlag ? 'primary' : ''" v-bind='attrs' v-on='on'
                  @click="addLike('down')" size='20'
                  class='cursor-pointer ml-2'>
            {{ icons.mdiThumbDownOutline }}
          </v-icon>
        </template>
        <span>Dislike</span>
      </v-tooltip>
    </div>
    <template v-if="showSatisfaction && showFeedback === 'true'">
      <div v-if="!$isMobile"
           class="feedback-container d-flex align-center ml-6">
        <v-img :src="require('@/assets/images/avatars/small-avatar.png')" class="mr-1"></v-img>
        <span class="mr-4 font-weight-black" :style="{fontSize: 'chinese' === language ? '13px' : '11px'}">
            {{ 'chinese' === language ? '以上方案是否已解决您的问题' : 'Has the current solution resolved your issue?' }}
          </span>
        <v-btn
          class="mr-2"
          rounded
          x-small
          :disabled="feedbackDisabled"
          :outlined="message.satisfactionFeedback !== '满意'"
          color="primary"
          @click="answerFeedback('满意')"
        >
          <span :style="getFeedbackButtonStyle()">
            {{ 'chinese' === language ? '是' : 'Yes' }}
          </span>
        </v-btn>
        <v-btn
          x-small
          rounded
          :disabled="feedbackDisabled"
          :loading="dissatisfiedLoading"
          :outlined="message.satisfactionFeedback !== '不满意'"
          color="primary"
          @click="answerFeedback('不满意')"
        >
        <span :style="getFeedbackButtonStyle()">
           {{ 'chinese' === language ? '否（创建IT事件工单）' : 'No (Raise IT incident ticket)' }}</span>
        </v-btn>
      </div>
    </template>
  </div>
</template>
<script>
import {
  mdiThumbUpOutline,
  mdiRefresh,
  mdiContentCopy,
  mdiThumbDownOutline,
  mdiAutorenew,
} from '@mdi/js'
import {
  addLike,
  refreshAnswer,
  getChatBotAnswerMessageById,
  submitSatisfactionFeedback,
  getWorkOrderDesc,
} from '../api/index'
import { mapGetters } from 'vuex'
import { store } from '@/myops/core'

export default {
  props: {
    msgId: {
      type: Number,
      default: 0,
    },
    isCustomCopyWriteText: {
      type: Boolean,
      default: false,
    },
    showRegenerate: {
      type: Boolean,
      default: true,
    },
    likeType: {
      type: String,
      default: null,
    },
    message: {
      type: Object,
      default: () => {
      },
    },
    showSatisfaction: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  watch: {
    likeType: {
      handler(val) {
        if (val === 'up') {
          this.likeFlag = true
          this.downLikeFlag = false
        } else if (val === 'down') {
          this.likeFlag = false
          this.downLikeFlag = true
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
      SHOW_SATIS_EID: 'chat/SHOW_SATIS_EID',
    }),
    feedbackDisabled() {
      return !!this.message.satisfactionFeedback
    },
  },
  data() {
    return {
      icons: { mdiThumbUpOutline, mdiRefresh, mdiContentCopy, mdiThumbDownOutline, mdiAutorenew },
      likeFlag: false,
      downLikeFlag: false,
      eid: store.state.user.user.eid,
      dissatisfiedLoading: false,
      showFeedback: process.env.VUE_APP_AI_ANSWER_FEEDBACK_ENABLED,
    }
  },
  methods: {
    getFeedbackButtonStyle() {
      return { fontSize: 'chinese' === this.language ? '12px' : '10px', color: this.feedbackDisabled ? '#7a7575' : '' }
    },
    async answerFeedback(value) {
      if (this.message.satisfactionFeedback === value) {
        return
      }
      this.$set(this.message, 'satisfactionFeedback', value)
      submitSatisfactionFeedback({
        answerId: this.msgId,
        satisfactionFeedback: value,
        chatSessionId: this.chatSessionId,
      }).then(result => {
        if (value === '满意') {
          this.$bus.$emit('addMessage', {
            type: 'answerSatisfactionFeedbackEmit',
            value: value,
            title: this.message.queryContent,
            desc: this.message.text,
            language: this.language,
          })
        }

      })
      if (value === '不满意') {
        this.dissatisfiedLoading = true
        getWorkOrderDesc({
          userQuery: this.message.queryContent,
          answer: this.message.text,
        }).then(result => {
          const resultData = result.data
          this.dissatisfiedLoading = false
          let isSuccessful = resultData.code === 200
          this.$bus.$emit('addMessage', {
            type: 'answerSatisfactionFeedbackEmit',
            value: value,
            title: isSuccessful ? resultData.data.short_description : this.message.queryContent,
            desc: isSuccessful ? resultData.data.description : this.message.text,
            language: this.language,
          })
        })
      }
    },
    async addLike(likeType) {
      if (this.msgId === 0) {
        return
      }
      if ((this.likeFlag && likeType === 'up') || (this.downLikeFlag && likeType === 'down')) {
        return
      }
      const { data: { code, data } } = await addLike({ answerId: this.msgId, likeType: likeType })
      if (code === 200) {
        this.likeFlag = data === 'up'
        this.downLikeFlag = data === 'down'
      }
    },
    async refreshAnswer() {
      if (this.msgId === 0) {
        return
      }
      this.$emit('refreshAnswer', this.message)
    },
    async copy() {
      if (!navigator.clipboard) {
        console.error('Clipboard API is not supported in this browser.')
        return
      }
      if (this.isCustomCopyWriteText) {
        this.$emit('copy', this.msgId)
      } else if (this.message.text) {
        await navigator.clipboard.writeText(this.message.text)
        this.$message.success('复制成功')
      } else {
        try {
          const { data: { code, data } } = await getChatBotAnswerMessageById({ id: this.msgId })
          await navigator.clipboard.writeText(data.answerContent)
          this.$message.success('复制成功')
        } catch (err) {
          console.error('无法复制文本：', err)
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.feedback-container {
  background: #FAF7FF;
  padding: 5px 13px;
  border-radius: 28px;
}
</style>
